export class Configuration{
    
    serverUrl            : string;
    
    reportsAppUrl        : string;
    salesReportsAppUrl   : string;

    reportServerUrl      : string;
    pageSize             : number;
    lovPageSize          : number;


    reportCommand        : string;
    currency      : string;

    constructor(){
        
    }
}